<template>
  <Dropzone
    v-slot="{ active }"
    class="z-0 p-5 bg-background-light-110 rounded-4 relative"
    @files="addFiles"
  >
    <StripedBox
      border-color="var(--color-red-10)"
      border-radius="4px"
      class="box cursor-pointer"
      :class="{ active }"
      :active="true"
      :aspect="aspect"
      @click.prevent.stop="emit('click')"
    >
      <div class="drop-box w-full h-full">
        <Box
          :aspect="1"
          class="placeholder"
          use-height
        >
          <div class="flex flex-col gap-y-5 items-center">
            <CloudIcon class="m-auto w-9.5" />
            <span class="">
              {{ label ?? $t("chooseFile") }}
            </span>
          </div>
        </Box>
      </div>
    </StripedBox>
  </Dropzone>
</template>

<script lang="ts" setup>
import type { Component } from 'vue';
import CloudIcon from '@images/cloud.svg?component';
import { useVModel } from '@vueuse/core';
import Box from '../Box.vue';
import Dropzone from '../Dropzone.vue';
import type { WbFile } from '@/entities/Entities';
import StripedBox from '../StripedBox.vue';
import { Upload, type FileUpload } from '../upload/fileUpload';

interface Props {
  acceptedFiles?: string;
  aspect?: number;
  label?: string;
  icon?: Component;
  modelValue?: FileUpload<WbFile>[];
}

const props = defineProps<Props>();

const emit = defineEmits(['update:modelValue', 'click']);
const value = useVModel(props, 'modelValue', emit, { passive: true });

const addFiles = (files: File[]) => {
  const uploads = [...(files ?? [])].map((file) => Upload.from<WbFile>(file));
  value.value = [...(value.value as FileUpload<WbFile>[]), ...uploads];
};
</script>

<style lang="scss" scoped>
.progress {
  @apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2;
  @apply w-9/12;
}

.placeholder :deep(.box-content) {
  @apply flex justify-center items-center h-full pointer-events-none;
  @apply text-red-10;
  @apply select-none;
}

:deep(.box.active) {
  --stripe-box-border-color: var(--color-text-dark-100);
}
</style>
